'use strict';

import {BaseElement} from "../../../../interfaces/BaseElement";
import {EventBus} from "../../../../interfaces/EventBus";
import {changeLangToCurrent} from "../../../../components/langSwitcher/langSwitcher";
import {searchGetResults} from "../../search";

export class ResultsAmount {
    #rootElement;
    #counter;

    constructor() {
        this.#rootElement = new BaseElement()
            .addClass('mobile-search__results-amount');

        this.#counter = new BaseElement('span')
            .addClass('results-amount__counter')
            .innerHtml(0)
            .appendTo(this.#rootElement.DOMElement);

        new BaseElement('span')
            .addClass('results-amount__text', 'language-string')
            .addAttribute('data-dictionary', 'ApartmentsShort')
            .innerHtml(changeLangToCurrent('ApartmentsShort'))
            .appendTo(this.#rootElement.DOMElement);

        EventBus.add('mobileSearchResultsAmountUpdate', this.#update.bind(this));
    }

    get rootElement() {
        return this.#rootElement;
    }

    #update() {
        const amount = this.#rootElement.DOMElement
            .closest('.mobile-search__bottom-element')
            .querySelector('.mobile-search__content-wrapper')
            .children.length;

        this.#counter.innerHtml(amount);
        EventBus.trigger('updateApplyBtnCount', amount);
    }

    remove() {
        EventBus.remove('mobileSearchResultsAmountUpdate');

        this.#rootElement.remove();
        this.#rootElement = null;
    }
}